import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 4C2 3.44772 2.44772 3 3 3H16C16.5523 3 17 3.44772 17 4C17 4.55228 16.5523 5 16 5H3C2.44772 5 2 4.55228 2 4ZM2 8C2 7.44772 2.44772 7 3 7H12C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H3C2.44772 9 2 8.55228 2 8ZM17 7C17.5523 7 18 7.44772 18 8V17.5858L20.2929 15.2929C20.6834 14.9024 21.3166 14.9024 21.7071 15.2929C22.0976 15.6834 22.0976 16.3166 21.7071 16.7071L17.7071 20.7071C17.5121 20.9021 17.2567 20.9997 17.0011 21C17.0008 21 17.0004 21 17 21C16.8644 21 16.7351 20.973 16.6171 20.9241C16.4992 20.8753 16.3888 20.803 16.2929 20.7071L12.2929 16.7071C11.9024 16.3166 11.9024 15.6834 12.2929 15.2929C12.6834 14.9024 13.3166 14.9024 13.7071 15.2929L16 17.5858V8C16 7.44772 16.4477 7 17 7ZM2 12C2 11.4477 2.44772 11 3 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H3C2.44772 13 2 12.5523 2 12Z"
    />
  </svg>
);

const SortDescendingIcon = (props) => <Icon component={SVG} {...props} />;

export default SortDescendingIcon;
